module.exports = __webpack_public_path__ + "img/delivery2.4fbe6c90.png";